import { useCurrentAccountQuery } from "../api/queries/useAccountQuery";
import { LENGTH_UNITS, WEIGHT_UNITS } from "../consts/api";

export const useCalculateBmi = () => {
  const { data: account } = useCurrentAccountQuery();

  const weightUnit_ = account?.preferences?.weightUnit || WEIGHT_UNITS.kilogram;

  const lengthUnit_ =
    account?.preferences?.lengthUnit || LENGTH_UNITS.centimeter;

  return ({
    weight,
    height,
    weightUnit = weightUnit_,
    lengthUnit = lengthUnit_,
  }) => {
    if (weight && height) {
      let heightInMeters = height;
      let weightInKg = weight;

      if (lengthUnit === LENGTH_UNITS.inch) {
        heightInMeters = height * 0.0254;
      } else if (lengthUnit === LENGTH_UNITS.centimeter) {
        heightInMeters = height / 100;
      }

      if (weightUnit === WEIGHT_UNITS.pound) {
        weightInKg = weight * 0.453592;
      }

      const bmi = weightInKg / (heightInMeters * heightInMeters);

      return Math.round(bmi * 10) / 10;
    }

    return 0;
  };
};
